package com.eladfinish.bible.contest.screens.main.usecases

import com.eladfinish.bible.contest.screens.main.data.ButtonType

/**
 * The main screen grid should always show an even number of buttons
 * (the "remove ads" button is rendered separately and is not part of this count).
 *
 * If the count is odd, the [ButtonType.HELP] button is removed from the grid
 * and shown in the toolbar instead.
 */
class EvenButtonGridUseCase {

    /**
     * Returns the button list that should be shown in the main screen grid:
     * [buttonTypes] as-is if its size is even, otherwise with [ButtonType.HELP] removed.
     */
    fun gridButtonTypes(buttonTypes: List<ButtonType>): List<ButtonType> {
        return if (buttonTypes.size % 2 != 0) {
            buttonTypes.filterNot { it == ButtonType.HELP }
        } else {
            buttonTypes
        }
    }

    /**
     * Returns whether [ButtonType.HELP] should be shown in the toolbar instead of the grid,
     * i.e. whether [buttonTypes] has an odd size and contains [ButtonType.HELP].
     */
    fun isHelpInToolbar(buttonTypes: List<ButtonType>): Boolean {
        return buttonTypes.size % 2 != 0 && buttonTypes.contains(ButtonType.HELP)
    }
}
